import { ACTION_TRACKING, ACTION_TRACKING_DISPATCHED, ACTION_TRACKING_HIT_RECEIVED, ACTION_TRACKING_INVALID_HIT, ACTION_TRACKING_INVALID_NONCE } from '../enum/FlagshipConstant';
import { EventCategory } from '../hit/index';
import { SharedActionSource } from '../type.local';
import { isBrowser, logDebugSprintf } from '../utils/utils';
import { Event } from '../hit/Event.ts';
export class SharedActionTracking {
    visitor = null;
    onMessageReceived;
    trustedNonces;
    initTimestamp;
    sdkConfig;
    constructor({ sdkConfig }) {
        this.trustedNonces = {};
        this.sdkConfig = sdkConfig;
    }
    generateNonce() {
        if (!isBrowser() || !this.visitor || !this.visitor.hasConsented) {
            return undefined;
        }
        const nonce = Math.random().toString(36).substring(2) + Date.now().toString(36);
        this.trustedNonces[nonce] = false;
        return nonce;
    }
    initialize(visitor) {
        this.visitor = visitor;
        this.initTimestamp = Date.now();
        if (!isBrowser()) {
            return;
        }
        if (this.onMessageReceived) {
            window?.removeEventListener('message', this.onMessageReceived);
        }
        this.onMessageReceived = (event) => {
            this.handleMessage(event);
        };
        window?.addEventListener('message', this.onMessageReceived);
    }
    async processHit(hit) {
        if (hit?.ec !== EventCategory.ACTION_TRACKING || !hit.ea) {
            logDebugSprintf(this.sdkConfig, ACTION_TRACKING, ACTION_TRACKING_INVALID_HIT, hit);
            return;
        }
        const eventHit = new Event({
            category: hit.ec,
            action: hit.ea,
            label: hit.el,
            value: hit.ev,
            visitorId: this.visitor?.visitorId,
            anonymousId: this.visitor?.anonymousId,
            isActionTrackingHit: true
        });
        this.visitor?.addInTrackingManager(eventHit);
        logDebugSprintf(this.sdkConfig, ACTION_TRACKING, ACTION_TRACKING_HIT_RECEIVED, hit);
    }
    handleMessage(event) {
        if (!event?.data || event?.origin !== window.location.origin || !this.visitor?.hasConsented) {
            return;
        }
        const payload = event.data;
        if (payload.action !== SharedActionSource.ABT_TAG_TRACK_ACTION || !payload.nonce) {
            return;
        }
        const { nonce } = payload;
        if (this.trustedNonces[nonce] === undefined || this.trustedNonces[nonce]) {
            logDebugSprintf(this.sdkConfig, ACTION_TRACKING, ACTION_TRACKING_INVALID_NONCE, nonce);
            return;
        }
        this.trustedNonces[nonce] = true;
        const hits = payload.data;
        if (!hits || !hits.length) {
            return;
        }
        for (const hit of hits) {
            this.processHit(hit);
        }
    }
    dispatchEventHits(hits) {
        if (!this.shouldProcessHits(hits)) {
            return;
        }
        const nonce = this.getNonce();
        if (!nonce) {
            return;
        }
        const hitsToDispatch = this.filterHitsToDispatch(hits);
        if (!hitsToDispatch.length) {
            return;
        }
        this.postHits(hitsToDispatch, nonce);
    }
    shouldProcessHits(hits) {
        return isBrowser() && !!this.visitor && !!hits && hits.length > 0;
    }
    getNonce() {
        return window.ABTasty?.api?.internal?._getActionTrackingNonce?.();
    }
    filterHitsToDispatch(hits) {
        return hits
            .filter(hit => {
            const isHitPostInit = this.initTimestamp && hit.createdAt >= this.initTimestamp;
            const isHitForVisitor = hit.visitorId === this.visitor?.visitorId || hit.visitorId === this.visitor?.anonymousId;
            return hit.data.ec === EventCategory.ACTION_TRACKING && isHitPostInit && isHitForVisitor;
        })
            .map(hit => hit.data);
    }
    postHits(hitsToDispatch, nonce) {
        const payload = {
            action: SharedActionSource.ABT_WEB_SDK_TRACK_ACTION,
            data: hitsToDispatch,
            nonce,
            timestamp: Date.now()
        };
        window?.postMessage(payload, window.location.origin);
        logDebugSprintf(this.sdkConfig, ACTION_TRACKING, ACTION_TRACKING_DISPATCHED, hitsToDispatch);
    }
}
